export default {
  errorsRootKey: 'emailtemplates',
  resource: 'emailtemplates',
  actions: ['index', 'show', 'create', 'update', 'destroy']
}
